module.exports = __webpack_public_path__ + "static/media/tickmarkLogoSmall.91835338.svg";